import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch } from 'react-router-dom';

import { history } from 'redux/store';
import Dashboard from 'app/screens/Dashboard';
import PublicDashboard from 'app/screens/PublicDashboard';
import SignIn from 'app/screens/SignIn';
import SignUp from 'app/screens/SignUp';
import Maintenance from 'app/screens/Maintenance';
import EntitiesComplaints from 'app/screens/EntitiesComplaints';
import NewForm from 'app/screens/NewForm';
import { ROUTES, ROUTE_TYPES } from 'constants/routes';
import PaymentsForNis from 'app/screens/PaymentsForNis';

import PaymentResult from '../PaymentResult';

import RouteHandler from './components/RouteHandler';

const { PUBLIC, PRIVATE, RESTRICTED } = ROUTE_TYPES;

function Routes() {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <RouteHandler type={PUBLIC} path={ROUTES.PAYMENT_RESULT} component={PaymentResult} />
        <RouteHandler type={RESTRICTED} exact path={ROUTES.SIGN_IN} component={SignIn} />
        <RouteHandler type={RESTRICTED} exact path={ROUTES.SIGN_IN_PASSWORD_RECOVERY} component={SignIn} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.PUBLIC_NIS_PAYMENTS} component={PaymentsForNis} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.SIGN_IN_CHANGE_PASSWORD} component={SignIn} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.SIGN_UP} component={SignUp} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.MAINTENANCE} component={Maintenance} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.ENTITIES_COMPLAINTS} component={EntitiesComplaints} />
        <RouteHandler type={PUBLIC} exact path={ROUTES.NEW_FORM} component={NewForm} />
        <RouteHandler type={RESTRICTED} path={ROUTES.PUBLIC_DASHBOARD} component={PublicDashboard} />
        <RouteHandler type={PRIVATE} path={ROUTES.ACCOUNT_STATUS} component={Dashboard} />
      </Switch>
    </ConnectedRouter>
  );
}

export default Routes;
